import type { ActionDoc } from "@shared/models/action"
import type { PreparedAction } from "cc-frontend/lib/action-doc-builder"
import type Dispatcher from "cc-frontend/services/dispatcher"
import { useMemo } from "react"
import { useEmberService } from "react-app/providers/ember-service-context"

/**
 * Returns a stable reference to the Ember `dispatcher.dispatchPreparedAction` function.
 */
export function useDispatch(): (preparedAction: PreparedAction) => ActionDoc {
  const dispatcher = useEmberService<Dispatcher>("dispatcher")
  return useMemo(() => dispatcher.dispatchPreparedAction.bind(dispatcher), [dispatcher])
}
